const initialState = {};

const reductions = {
  SET_STAT: function (state, action) {
    if (action.payload.key && action.payload.value) {
      return Object.assign({}, state, {
        [action.payload.key]: action.payload.value,
      });
    }

    return state;
  },
};

const statsReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default statsReducer;
